function directive(Global, $compile) {
    return {
        transclude : true,
        template: `<div class="qr-inner"></div>`,
        link: function ($scope, element, attr) {
            // import renderer
            var qr = require('../../../system/assets/scripts/qr');
            attr.$observe('code', function (value) {
                // create a new instance just in case the plugin keeps state
                let q = Object.create(qr);
                // do nothing if code attrib not defined
                if (!attr.hasOwnProperty('code')) { return }
                // do nothing if code is empty
                if (attr.code === '') { return }
                // clear existing html data
                element.html('');
                // append new html data
                element.append($compile(q.generateHTML(value, { modulesize: 4 }))($scope));
            });
        }
    };
}

directive.$inject = ['Global', '$compile'];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/qrcode/qrcode.js
 **/